import { formaters } from "vincent-utils";
import {Button} from "@/components/ui/button";
import styles from "./RdvCandidat.module.css";

export interface Candidat {
  score: number;
  date: Date;
  hour: number;
  minute: number;
}

export interface RdvCandidatProps {
  isPatientSelected: boolean;
  candidat: Candidat;
  onCreatePatient: () => void;
  onCreateRdv: (candidat: Candidat) => void;
}

const RdvCandidat = (props: RdvCandidatProps) => {
  const { isPatientSelected, onCreatePatient, onCreateRdv, candidat } = props;
  const button = isPatientSelected ? (
    <Button onClick={() => onCreateRdv(candidat)} size="sm">
      Créer RDV
    </Button>
  ) : (
    <Button onClick={onCreatePatient} size="sm" variant="secondary">
      Créer Patient
    </Button>
  );
  return (
    <>
      <div className={styles.date}>
        {formaters.formatDateForDisplayWithDay(candidat.date)}{" "}
        {formaters.formatHourMinuteObjectForDisplay(candidat)}
      </div>{" "}
      <div className={styles.score}>score:{candidat.score}</div>
      <div className={styles.button}>{button}</div>
    </>
  );
};

export default RdvCandidat;
